webpackJsonp([212839066777427],{

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _Segment3 = __webpack_require__(229);
	
	var _Segment4 = _interopRequireDefault(_Segment3);
	
	var _Label3 = __webpack_require__(112);
	
	var _Label4 = _interopRequireDefault(_Label3);
	
	var _Header3 = __webpack_require__(29);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _Container3 = __webpack_require__(26);
	
	var _Container4 = _interopRequireDefault(_Container3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _disqusReact = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	
	  var Posts = edges.filter(function (edge) {
	    return !!edge.node.frontmatter.date;
	  }).map(function (_ref2) {
	    var post = _ref2.node.frontmatter;
	
	    return _react2.default.createElement(
	      _Segment4.default,
	      { key: post.id, stacked: true, textAlign: 'center', padded: 'very' },
	      _react2.default.createElement(_Header4.default, { as: 'h2', content: _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.path },
	          post.title
	        ) }),
	      _react2.default.createElement(_Label4.default, { icon: 'time', size: 'tiny', basic: true, content: post.date }),
	      _react2.default.createElement(_Label4.default, {
	        icon: 'comment',
	        size: 'tiny',
	        basic: true,
	        content: _react2.default.createElement(_disqusReact.CommentCount, {
	          shortname: 'fake-flight-tickets',
	          config: {
	            url: 'https://www.fakeflighttickets.com' + post.path,
	            identifier: post.id,
	            title: post.title
	          }
	        })
	      })
	    );
	  });
	
	  return _react2.default.createElement(
	    _Container4.default,
	    { text: true },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Blog - Fake Flight Tickets'
	      ),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: 'Blog - Fake Flight Tickets' })
	    ),
	    _react2.default.createElement(_Header4.default, { as: 'h1', content: 'Blog' }),
	    Posts
	  );
	};
	
	exports.default = BlogPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-f2389a4c9a6813c69994.js